import { Menu, Search } from 'components/header'
import { MenuItem } from './menu-item'

export class HeaderStore {
    public menu: Menu
    public search: Search
    // Touch Logic
    public lastTouchedL1Item?: MenuItem

    private static _instance: HeaderStore
    public static getInstance(): HeaderStore {
        return this._instance || (this._instance = new this())
    }
}
